
module.exports = { 
      attributes: {},
    
      body: "Services provided by a specialist in hospital that require particular skills, training, or equipment.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/specialists.md"},
     }